import React from 'react'
import PropTypes from 'prop-types'

const ToggleSimple = (props) => {
    return (
        <div className={`toggle-simple ${props.className} ${props.value ? 'active' : ''}`}>
            <input
                type='checkbox'
                className='checkbox'
                checked={props.value}
                onChange={props.handleChange}
            />
            <label htmlFor='toggle' className='switch' onClick={() => props.handleChange(!props.value)} />
        </div>
    )
}

ToggleSimple.propTypes = {
    value: PropTypes.bool.isRequired,
    handleChange: PropTypes.func.isRequired
}

ToggleSimple.defaultProps = {
    value: false
}

export default ToggleSimple



// WEBPACK FOOTER //
// ./resources/js/elements/ToggleSimple.js